import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { setFilters } from "../Gstr3BSummarySlice";

// ✅ IMPORT ALL THUNKS
import {
  fetchSection31,
  fetchSection311,
  fetchSection32,
  fetchSection4,
  fetchSection5,
} from "../Gstr3BSummaryThunk";

import { fetchTaxAccs } from "../../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";

const Gstr3BFilters = ({ messageApi, onReport }) => {
  const dispatch = useDispatch();

  const { filters } = useSelector((state) => state.gstr3b);
  const { taxAccs } = useSelector((state) => state.lookups);

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchTaxAccs());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  // ✅ UPDATED REPORT HANDLER
  const handleReport = async () => {
    if (!filters.accId) {
      messageApi?.warning("Select Account");
      return;
    }

    try {
      await Promise.all([
        dispatch(fetchSection31(filters)),
        // dispatch(fetchSection311(filters)),
        // dispatch(fetchSection32(filters)),
        dispatch(fetchSection4(filters)),
        dispatch(fetchSection5(filters)),
      ]);

      messageApi?.success("GSTR-3B loaded ✅");
    } catch (err) {
      messageApi?.error("Failed ❌");
    }
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">

        {/* Account Selector */}
        <Col xs={24} sm={12} md={6}>
          <label>Account</label>
          <SearchListAutoComplete
            optionsList={(taxAccs || [])
              .filter((acc) => {
                const name = acc.acc_name.toLowerCase();
                return name.includes("vat") || name.includes("gst");
              })
              .map((acc) => ({
                sale_id: acc.acc_id,
                display_text: acc.acc_name,
              }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Tax Account"
            showAddNew={false}
          />
        </Col>

        {/* Date Filter */}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        {/* Report Button */}
        <Col
          xs={24}
          sm={12}
          md={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{ height: 35 }}
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default Gstr3BFilters;